module.exports = __webpack_public_path__ + "static/media/principal.5927c48f.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/que/principal.jpg
 ** module id = 154
 ** module chunks = 0
 **/